import React, { useState } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { responsive } from "../../utils/style";

import Arrow from "../../assets/icons/Arrow.png";

const ExpandableTab = ({ label, children }) => {
  const [active, setActive] = useState(false);
  return (
    <>
      <TabContainer onClick={() => setActive(!active)}>
        <TabLabel>
          <b>{label}</b>
        </TabLabel>
        <TabArrowContainer>
          <TabLabelOpen active={active}>อ่าน</TabLabelOpen>
          <TabArrow active={active} src={Arrow} />
        </TabArrowContainer>
      </TabContainer>
      <TabContent active={active}>{children}</TabContent>
    </>
  );
};

const CustomLine = ({ prefix, score }) => {
  return (
    <div style={{ width: "250px", display: "flex" }}>
      <div style={{ width: "65%" }}>{prefix} </div>
      <div style={{ width: "35%" }}>= {score} คะแนน</div>
    </div>
  );
};

const blankGen = (n) => new Array(n).fill(0).map((i) => <>&nbsp;</>);

const ScoreRules = () => {
  return (
    <Container>
      <Background>
        <Topic>กติกาและการคิดคะแนน</Topic>
        <ExpandableTab label="กติกาการแข่งขัน">
          <Text>
            <Indent />
            การแข่งขันในเกมเณรกล้า โภชนาดี
            เป็นการตั้งเป้าหมายการฉันอาหารและออกกำลังกายให้สามเณรฝึกปฏิบัติตามและค่อย
            ๆ ปรับเปลี่ยนการฉัน
            และการออกกำลังกายมุ่งไปสู่เป้าหมายของการมีสุขภาพดี มีความสมส่วน
            ไม่อ้วนไป ไม่ผอมไป สูงดีเต็มศักยภาพ ไม่เตี้ยไป โดยเกมนี้มี 4
            เป้าหมาย (ซึ่งได้มาจากการวิจัย)
            อันเป็นจุดสำคัญในการสร้างสุขภาพแก่สามเณร
            โดยให้สามเณรกรอกปริมาณที่กินหรือออกกำลังใน1 วันก่อนหน้าวันที่
            กรอกข้อมูล คือ <br />
            1) ดื่มดี นมวัว เน้นให้คะแนนการดื่มนมวัวจืด
            แต่เกมนี้ยังให้คะแนนการดื่มนมวัวปรุงแต่งรสหวาน
            และการดื่มนมถั่วเหลือง แต่คะแนนจะลดหลั่นกันไป <br />
            2) สุขชัวร์ เพิ่มผัก ให้คะแนนตามปริมาณผักทั้งหมดที่ฉันได้ <br />
            3) รัก ออกกำลัง ให้คะแนนตามระยะเวลาที่ออกกำลังได้ <br />
            4) หยุดยั้งน้ำหวาน ให้คะแนน การดื่มน้ำเปล่าสูงที่สุด รองลงมาคือ
            เครื่องดื่มหวานน้อย ส่วนการดื่มน้ำหวาน จะได้คะแนนน้อยที่สุด
            <br />
            <b>
              โปรดสังเกตว่า การดื่มนมวัว เราไม่ได้เน้นให้ดื่มจนมากเกินไป ดังนั้น
              ผู้ดื่มมากกว่า 2 แก้วต่อวันไม่ได้คะแนนเพิ่ม การฉันผักและการออก
              กำลังกาย ก็เน้นให้กินพอดี
              ถ้าปฏิบัติมากกว่าเป้าหมายก็ไม่ได้คะแนนเพิ่ม ไม่ต้องกินจนมากไป หรือ
              ออกกำลังจนมากเกินไป ส่วนการดื่มน้ำหวาน เน้นการดื่มน้ำเปล่า
              ถ้าประสงค์เครื่องดื่มหวาน ก็ให้เลือกที่หวานน้อย
              การดื่มเครื่องดื่มหวาน ขนาดกลาง จำนวน 2 กล่อง/ขวด/ถ้วย ขึ้นไป
              จะถูกตัดคะแนนเป็น 0
            </b>
          </Text>
          <GroupSection>
            <Section>1. การเปิดเกมและการลงทะเบียน</Section>
            <GroupItem>
              <li>
                ให้พระอาจารย์หรือครูฆราวาสผู้รับผิดชอบในรายวิชาสุขศึกษาของโรงเรียนพระปริยัติธรรมที่เป็นบุคคลหลักในการเป็นโค้ชให้กับสามเณร
                (เรียกว่า หัวหน้าโค้ช) เป็นผู้เปิดเกม โดยเข้าลงทะเบียนเป็นคนแรก
                ทั้งนี้เว็บแอปพลิเคชันนี้ จะไม่มีการระบุชื่อโรงเรียน
                เพื่อให้ข้อมูลต่างๆไม่สามารถระบุตัวตนได้
              </li>
              <li>
                ระบุชื่อของพระอาจารย์หรือครูฆราวาสที่เป็นโค้ชหลัก(หัวหน้าโค้ช)โดยหลีกเลี่ยงการใช้ชื่อจริงเพื่อให้ข้อมูลต่างๆไม่สามารถระบุตัวตนได้
              </li>
              <li>
                กำหนดรหัสผ่าน (Password) ของตนเอง
                ที่จำง่ายเพื่อไว้สำหรับลงชื่อเข้าใช้ (Log in)
              </li>
              <li>
                ระบุระยะเวลาของเกมการแข่งขัน โดยเลือกได้ 4แบบ คือ 4, 8, 12, และ
                16 สัปดาห์
              </li>
              <li>
                ระบุวันเปิดเกม
                โดยกำหนดให้เป็นวันจันทร์เป็นวันเริ่มต้นของเกมและโค้ชต้องแจ้งวันเปิดเกมและวันสิ้นสุดเกมให้สามเณรทราบ
                ทั้งสามเณรและทีม ครูอาจารย์ควรลงทะเบียนให้เสร็จก่อนวันเปิดเกม
              </li>
              <li>ระบุ จำนวนห้องเรียน และชั้นเรียนของสามเณรที่จะร่วมเล่นเกม</li>
              <li>
                สร้างโค้ดลงทะเบียนสำหรับสามเณรที่จะเข้าร่วมเล่นเกมและโค้ดลงทะเบียนสำหรับทีมครูอาจารย์ที่ประสงค์จะร่วมเป็นทีมโค้ชให้สามเณร
                โดยแนะนำให้สร้างโค้ดที่จดจำง่ายๆ (ไม่ควรใช้ชื่อโรงเรียน)
                โดยโค้ดสำหรับสามเณรและโค้ดสำหรับทีมครูอาจารย์ต้องแตกต่างกัน
                และทีมครูอาจารย์
                ควรเก็บรักษาโค้ดของทีมครูอาจารย์ไม่ให้สามเณรทราบ
              </li>
              <li>
                ส่งโค้ดลงทะเบียนให้กับสามเณรที่จะเข้าร่วมเล่นเกม
                และพระอาจารย์หรือครูฆราวาสที่ร่วมเป็นทีมโค้ชให้สามเณร
                สามเณรและทีมครูอาจารย์ จะลงทะเบียนได้
                ต่อเมื่อได้รับโค้ดลงทะเบียนจากหัวหน้าโค้ช
              </li>
            </GroupItem>
            <Section>การลงทะเบียนของสามเณร</Section>
            <GroupItem>
              <li>ใส่รหัสลงทะเบียนของสามเณรที่ได้จากหัวหน้าโค้ช</li>
              <li>
                ระบุ ชื่อ (ไม่ต้องระบุนามสกุล) และชื่อเล่น ห้องเรียน
                และชั้นเรียน ของสามเณร เพื่อให้ทีมโค้ชทราบว่าเป็นสามเณรรูปใด
              </li>
              <li>
                กำหนดรหัสผ่าน (Password) ของตนเองที่จำง่าย
                (สามเณรอาจจะลืมรหัสผ่านได้ง่าย) เพื่อไว้สำหรับลงชื่อเข้าใช้ (Log
                in)
              </li>
              <li>
                เมื่อลงทะเบียนผ่าน ในระหว่างการเล่นเกม
                สามเณรสามารถขอทราบผลของตนเองแต่ไม่สามารถขอดูผลของสามเณรรูปอื่นได้
              </li>
            </GroupItem>
            <Section>
              การลงทะเบียนของทีมครูอาจารย์
              ที่ร่วมทีมดูแลการใช้เว็บแอปพลิเคชันของสามเณร
            </Section>
            <GroupItem>
              <li>ใส่รหัสลงทะเบียนของทีมครูอาจารยที่ได้จากหัวหน้าโค้ช</li>
              <li>
                ระบุชื่อของพระอาจารย์หรือครูฆราวาสที่เป็นทีมโค้ช
                โดยหลีกเลี่ยงการใช้ชื่อจริง
              </li>
              <li>
                กำหนดรหัสผ่าน (Password) ของตนเอง ที่จำง่าย
                เพื่อไว้สำหรับลงชื่อเข้าใช้ (Log in)
              </li>
              <li>ทีมโค้ชสามารถขอทราบผลของสามเณรเป็นรายบุคคลและรายกลุ่มได้</li>
            </GroupItem>
          </GroupSection>

          <GroupSection>
            <Section>2. การกรอกข้อมูล</Section>
            <GroupItem>
              <li>
                ให้สามเณรบันทึกข้อมูลของ 4 เป้าหมาย
                ในการฉันอาหารและออกกำลังกายที่เกิดขึ้นในวันก่อนหน้าวันที่กรอก
                รวมทั้งวัน ตั้งแต่ตื่นนอนถึงเข้านอน
              </li>
              <HighLight>
                <span>
                  บันทึกข้อมูล<b>สัปดาห์ละ 1 วัน</b>วันใดก็ได้ของสัปดาห์นั้นๆ
                  ไปจนครบถึงสัปดาห์สุดท้ายของเกมที่หัวหน้า โค้ชได้กำหนดไว้
                </span>
              </HighLight>
              <li>
                การนับสัปดาห์ในการบันทึกข้อมูล จะเริ่มจากวันจันทร์เป็นวันที่ 1
                ของแต่ละสัปดาห์ไปจนวันอาทิตย์ของสัปดาห์นั้นเป็นวันสุดท้ายของสัปดาห์
                (ถ้าเลย
                สัปดาห์นั้นๆไปแล้วจะไม่สามารถกลับมากรอกข้อมูลย้อนหลังของสัปดาห์ก่อนหน้าได้)
              </li>
              <li>
                สำหรับการบันทึกข้อมูลภาวะโภชนาการ
                เป็นกิจกรรมที่เลือกทำตามความสมัครใจ
                โดยไม่มีผลต่อคะแนนในเกมการแข่งขัน ผู้กรอกข้อมูล
                จะเป็นสามเณรหรือครูผู้ใดผู้หนึ่งก็ได้ ตามแต่ตกลงกัน
                โดยกรอกข้อมูลต่อไปนี้ คือ น้ำหนัก ส่วนสูง ภาวะน้ำหนัก
                และภาวะส่วนสูง กรอกได้ 2 ครั้ง ต่อ 1 เกมการแข่งขัน โดยแนะนำให้
                กรอก 1 ครั้งช่วงเริ่มต้นเกมและอีก 1
                ครั้งตอนท้ายของเกมการแข่งขันเพื่อประเมินความเปลี่ยนแปลงของภาวะ
                โภชนาการของสามเณร หรือ จะกรอกเพียงครั้งเดียวตลอดเกมหรือ
                ไม่กรอกเลยก็ได้ ซึ่งครูสามารถพิจารณาได้ตามความเหมาะสม
              </li>
            </GroupItem>
          </GroupSection>
        </ExpandableTab>
        <ExpandableTab label="การคิดคะแนน">
          <Text>
            คะแนนรวมตลอดเกมของแต่ละเป้าหมาย และ รวม 4 เป้าหมาย
            ขึ้นกับระยะเวลาของเกมที่กำหนดไว้ (4 หรือ 8 หรือ 12 หรือ 16 สัปดาห์)
            <br />
          </Text>
          <TopicCenter>การคิดคะแนนแต่ละเป้าหมาย</TopicCenter>
          <HighLight>
            <Text>แต่ละเป้าหมายมีคะแนนเต็ม 10 คะแนนต่อ 1 วัน</Text>
            <Row>
              <Text>
                <b>
                  กรอกครบ 1 วันต่อสัปดาห์
                  <br />
                  กรอกครบ 4 สัปดาห์
                  <br />
                  กรอกครบ 8 สัปดาห์ <br />
                  กรอกครบ 12 สัปดาห์ <br />
                  กรอกครบ 16 สัปดาห์
                </b>
              </Text>
              &ensp;
              <Text>
                คะแนนเต็ม = 10 คะแนนต่อสัปดาห์
                <br /> คะแนนเต็ม = 40 คะแนนต่อ 4 สัปดาห์ <br />
                คะแนนเต็ม = 80 คะแนนต่อ 8 สัปดาห์ <br />
                คะแนนเต็ม = 120 คะแนนต่อ 12 สัปดาห์ <br />
                คะแนนเต็ม = 160 คะแนนต่อ 16 สัปดาห์
              </Text>
            </Row>
          </HighLight>

          <TopicCenter>คะแนนรวม 4 เป้าหมาย</TopicCenter>
          <HighLight>
            <Text>
              แต่ละเป้าหมายมีคะแนนเต็ม 10 คะแนนใน 1 วัน ทั้งหมดมี 4 เป้าหมาย รวม
              40 คะแนนต่อวัน
            </Text>
            <Row>
              <Text>
                <b>
                  กรอกครบ 4 เป้าหมาย ใน 1 วันต่อสัปดาห์ <br />
                  กรอกครบ 4 เป้าหมาย ครบ 4 สัปดาห์ <br />
                  กรอกครบ 4 เป้าหมาย ครบ 8 สัปดาห์ <br />
                  กรอกครบ 4 เป้าหมาย ครบ 12 สัปดาห์ <br />
                  กรอกครบ 4 เป้าหมาย ครบ 16 สัปดาห์{" "}
                </b>
              </Text>
              &ensp;
              <Text>
                คะแนนเต็ม = 40 คะแนนต่อสัปดาห์
                <br /> คะแนนเต็ม = 160 คะแนนต่อ 4 สัปดาห์ <br />
                คะแนนเต็ม = 320 คะแนนต่อ 8 สัปดาห์ (ครึ่งภาคการศึกษา) <br />
                คะแนนเต็ม = 480 คะแนนต่อ 12 สัปดาห์ <br />
                คะแนนเต็ม = 640 คะแนนต่อ 16 สัปดาห์ (1 ภาคการศึกษา)
              </Text>
            </Row>
          </HighLight>

          <Target>
            <TargetLabel>เป้าหมายที่ 1 ดื่มดี นมวัว</TargetLabel>
          </Target>
          <Text>
            มีเป้าหมายให้สามเณรดื่มนมวัวจืด วันละ 1-2 กล่อง/ขวด/ถ้วย ขนาดกลาง
          </Text>
          <GroupItem>
            <li>
              การให้คะแนนตามเป้าหมายที่ 1 ดื่มดี นมวัว
              จะให้คะแนนการดื่มนมวัวจืดสูงที่สุด รองลงมา คือนมวัวปรุงแต่งรส
            </li>
            <li>
              ส่วนนมถั่วเหลืองจะให้คะแนนด้วยแต่น้อยกว่านมวัว
              โดยนมถั่วเหลืองจืดมีคะแนนสูงกว่านมถั่วเหลืองรสหวาน
            </li>
            <li>
              เครื่องดื่มที่ไม่นับรวมในข้อนี้ คือ
              เครื่องดื่มที่มีเนื้อนมอยู่น้อย ไม่นับว่าเป็นนมวัว ได้แก่
            </li>
            <Indent>
              <GroupItem>
                <li>โยเกิรต์หรือนมเปรี้ยวพร้อมดื่ม</li>
                <li>
                  เครื่องดื่มที่มีนมวัวผสมลงไปบ้าง เช่น
                  เครื่องดื่มช็อกโกแลตใส่นม กาแฟใส่นม ชาใส่นม)
                  ถ้าดื่มในกลุ่มหลังนี้ ให้นำไปกรอกที่เครื่องดื่มรสหวาน
                  ในเป้าหมายที่ 4
                </li>
              </GroupItem>
            </Indent>
          </GroupItem>
          <GroupSection>
            <HighLight>
              <Text>
                <b className="f18">การคิดคะแนนในเป้าหมาย ดื่มดี นมวัว</b>
                <br />
                <b className="f18">นมวัวจืด</b>
                <br />
                <b className="f18">ขนาดเล็ก</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={5} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={10} />
                <b className="f18">ขนาดกลาง-ใหญ่</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={10} />
                <br />
                <b className="f18">นมวัวปรุงแต่ง</b>
                <br />
                <b className="f18">ขนาดเล็ก</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={4} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={8} />
                <b className="f18">ขนาดกลาง-ใหญ่</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={8} />
                <br />
                <b className="f18">นมถั่วเหลืองรสหวาน</b>
                <br />
                <b className="f18">ขนาดเล็ก</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={2} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย"} score={4} />
                <CustomLine prefix={"3 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={2} />
                <b className="f18">ขนาดกลาง</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={4} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={2} />
                <b className="f18">ขนาดใหญ่</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={2} />
                <br />
                <b className="f18">นมถั่วเหลืองจืด</b>
                <br />
                <b className="f18">ขนาดเล็ก</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={3} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย"} score={5} />
                <CustomLine prefix={"3 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={3} />
                <b className="f18">ขนาดกลาง </b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={5} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={3} />
                <b className="f18">ขนาดใหญ่</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={3} />
                <br />
                <b className="f18">การคิดคะแนนรวม</b>
                <br />
                คะแนนเต็ม 10 คะแนน <br />
                <GroupItem>
                  <li>
                    จะให้นำคะแนนของการดื่มนมวัวจืดและนมวัวปรุงแต่งทุกขนาดมารวมกัน
                    แต่ให้โดยคะแนนสูงสุดคือ 10 คะแนน ในกรณีไม่ดื่มนมวัว
                    จึงจะนำเอาคะแนนนมถั่วเหลืองมาคิดแทน
                    โดยเลือกเอาคะแนนของนมถั่วเหลืองจืดก่อน
                    (โดยเอาเฉพาะคะแนนขนาดใหญ่ที่สุดที่ดื่ม)
                  </li>
                  <li>
                    หากไม่ดื่มนมถั่วเหลืองจืดคือดื่มแต่นมถั่วเหลืองรสหวาน
                    จะนำคะแนนของนมถั่วเหลืองรสหวานมาใช้โดยนำคะแนนเฉพาะขนาดใหญ่ที่สุดที่ดื่ม
                  </li>
                </GroupItem>
              </Text>
            </HighLight>
          </GroupSection>

          <Target>
            <TargetLabel>เป้าหมายที่ 2 สุขชัวร์ เพิ่มผัก</TargetLabel>
          </Target>
          <Text>
            เป้าหมายคือบริโภคผักหลากหลาย วันละ 6-12
            ช้อนโต๊ะปริมาณที่บริโภครวมทั้งวัน
          </Text>
          <GroupItem>
            <li>
              1 ช้อนโต๊ะ
              {blankGen(16)}= 1 คะแนน
            </li>
            <li>
              2 ช้อนโต๊ะ
              {blankGen(16)}= 2 คะแนน
            </li>
            <li>
              3 ช้อนโต๊ะ
              {blankGen(16)}= 3 คะแนน
            </li>
            <li>
              4 ช้อนโต๊ะ
              {blankGen(16)}= 4 คะแนน
            </li>
            <li>
              5 ช้อนโต๊ะ
              {blankGen(16)}= 5 คะแนน
            </li>
            <li>
              6 ช้อนโต๊ะ
              {blankGen(16)}= 6 คะแนน
            </li>
            <li>
              7 ช้อนโต๊ะ
              {blankGen(16)}= 7 คะแนน
            </li>
            <li>
              8 ช้อนโต๊ะ
              {blankGen(16)}= 8 คะแนน
            </li>
            <li>
              9 ช้อนโต๊ะ
              {blankGen(16)}= 9 คะแนน
            </li>
            <li>
              10 ช้อนโต๊ะ
              {blankGen(14)}= 10 คะแนน
            </li>
            <li>มากกว่า 10 ช้อนโต๊ะ = 10 คะแนน</li>
          </GroupItem>

          <Target>
            <TargetLabel>เป้าหมายที่ 3 รักออกกำลัง</TargetLabel>
          </Target>
          <Text>
            เป้าหมายคือ ออกกำลังรวมทุกประเภท เช่น เดิน ยกของ วิดพื้น รวมวันละ 60
            นาที ระยะเวลาที่ออกกำลังทุกประเภท รวมใน 1 วัน
          </Text>
          <GroupItem>
            <li>10-15 นาที {blankGen(9)}= 1 คะแนน</li>
            <li>16-20 นาที {blankGen(9)}= 2 คะแนน</li>
            <li>21-25 นาที {blankGen(9)}= 3 คะแนน</li>
            <li>26-30 นาที {blankGen(9)}= 4 คะแนน</li>
            <li>31-35 นาที {blankGen(9)}= 5 คะแนน</li>
            <li>36-40 นาที {blankGen(9)}= 6 คะแนน</li>
            <li>41-45 นาที {blankGen(9)}= 7 คะแนน</li>
            <li>46-50 นาที {blankGen(9)}= 8 คะแนน</li>
            <li>51-55 นาที {blankGen(9)}= 9 คะแนน</li>
            <li>56-60 นาที {blankGen(9)}= 10 คะแนน</li>
            <li>61-100 นาที {blankGen(7)}= 10 คะแนน </li>
            <li>101-140 นาที {blankGen(5)}= 10 คะแนน </li>
            <li>141-180 นาที {blankGen(5)}= 10 คะแนน </li>
            <li>มากกว่า 180 นาที = 10 คะแนน</li>
          </GroupItem>
          <Target>
            <TargetLabel>เป้าหมายที่ 4 หยุดยั้งน้ำหวาน</TargetLabel>
          </Target>
          <Text>
            น้ำหวาน หมายถึง น้ำอัดลม เครื่องดื่มที่เติมน้ำตาล
            น้ำหวานที่เติมน้ำตาลเทียม และน้ำผลไม้ น้ำสมุนไพรที่มีรสหวาน
            โยเกิร์ตพร้อมดื่ม ชา กาแฟ
          </Text>
          <GroupSection>
            <HighLight>
              <Text>
                <b className="f18">การคิดคะแนนเป้าหมายหยุดยั้งน้ำหวาน</b>
                <br />
                จะเอาคะแนนน้ำหวานปกติมาคำนวนก่อน
                โดยเลือกปริมาตรที่ได้คะแนนน้อยที่สุด
                ถ้าไม่ดื่มน้ำหวานปกติจึงเอาคะแนน เครื่องดื่มหวานน้อย <br />
                โดยเลือกปริมาตรที่ได้คะแนนน้อยที่สุด <br />
                <br />
                ปริมาณที่ดื่มเครื่องดื่มรสหวานรวมใน 1 วัน ไม่ดื่มน้ำหวานเลย = 10
                คะแนน
                <br />
                <b className="f18">เครื่องดื่มหวานปกติ</b>
                <br />
                <b className="f18">ขนาดเล็ก</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={5} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย"} score={2} />
                <CustomLine prefix={"3 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={0} />
                <b className="f18">ขนาดกลาง</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={2} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={0} />
                <b className="f18">ขนาดใหญ่</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={0} />
                <br />
                <b className="f18">เครื่องดื่มหวานน้อย</b>
                <br />
                <b className="f18">ขนาดเล็ก</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={9} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย"} score={7} />
                <CustomLine prefix={"3 กล่อง/ขวด/ถ้วย"} score={5} />
                <CustomLine prefix={"4 กล่อง/ขวด/ถ้วย"} score={3} />
                <CustomLine prefix={"5 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={0} />
                <b className="f18">ขนาดกลาง</b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={6} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย"} score={4} />
                <CustomLine prefix={"3 กล่อง/ขวด/ถ้วย"} score={2} />
                <CustomLine prefix={"4 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={0} />
                <b className="f18">ขนาดใหญ่ </b>
                <br />
                <CustomLine prefix={"1 กล่อง/ขวด/ถ้วย"} score={3} />
                <CustomLine prefix={"2 กล่อง/ขวด/ถ้วย"} score={1} />
                <CustomLine prefix={"3 กล่อง/ขวด/ถ้วย ขึ้นไป"} score={0} />
              </Text>
            </HighLight>
          </GroupSection>
        </ExpandableTab>
      </Background>
    </Container>
  );
};

export default ScoreRules;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  width: 100%;
  background-color: #fffbeb;
`;

const Background = styled.div`
  width: 100%;
  max-width: 1144px;
  background-color: white;
  padding: 40px 116px;
  margin: auto;
  min-height: 100vh;

  ${responsive.tablet(css`
    padding: 40px 87px;
    max-width: unset;
  `)}

  ${responsive.mobile(css`
    padding: 24px 16px;
  `)}
`;

const Topic = styled.h5`
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #058459;
  margin-bottom: 24px;

  ${responsive.mobile(css`
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 18px;
  `)}
`;
const SubTopic = styled.h5`
  font-style: normal;
  font-weight: 700;
  font-size: 23px;
  line-height: 28px;
  color: #4b5768;

  ${responsive.mobile(css`
    font-size: 16px;
  `)}
`;
const GroupSection = styled.div`
  margin-bottom: 14px;
  font-size: 16px;

  ${responsive.mobile(css`
    font-size: 16px;
  `)}
`;
const Section = styled.h5`
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  color: #4b5768;
  font-size: 20px;

  ${responsive.mobile(css`
    font-size: 16px;
  `)}
`;
const GroupItem = styled.ul`
  list-style-position: inside;
  padding-left: 5px;

  li {
    font-size: 16px;
  }

  li > span {
    display: inline-block;
    width: 90%;
    > div {
      padding-left: 0px;
    }
  }

  > span {
    display: inline-block;
    width: 95%;
  }

  li.marker-none {
    &::marker {
      color: white;
      content: "";
    }

    .mark-l {
      margin-left: 24px;
    }
  }
`;
const Sublist = styled.div``;
const HighLight = styled.div`
  background: #b5f6df;
  border-radius: 8px;
  padding: 24px;
  margin: 5px 0;

  .bold {
    font-weight: bold;
  }
`;
const SubGroupItem = styled.div`
  display: grid;
  gap: 0 20px;
  grid-template-columns: 60% auto;
  padding-left: ${(props) => props.padL || "0px"};
`;
const Indent = styled.span`
  padding-left: 20px;
`;

const TabContainer = styled.div`
  height: 62px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #058459;
  border-radius: 8px;

  margin-bottom: 4px;

  :hover {
    cursor: pointer;
  }
`;

const TabArrowContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TabArrow = styled.img`
  width: 12px;
  height: 6px;

  margin: 0 30px 0 10px;
  transform: rotate(${(props) => (!props.active ? "180deg" : "0deg")});
  transition: 0.5s;
`;

const TabLabel = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-size: 22px;
  line-height: 26px;

  text-align: center;

  color: #ffffff;

  margin-left: 24px;
`;

const TabLabelOpen = styled(TabLabel)`
  display: ${(props) => (!props.active ? "block" : "none")};
`;

const TabContent = styled.div`
  display: ${(props) => (props.active ? "block" : "none")};
`;

const Text = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  color: #4b5768;

  > b.f18 {
    font-size: 18px;
  }
`;

const TopicCenter = styled.div`
  width: 100%;
  height: 32px;

  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;

  text-align: center;

  color: #4b5768;

  ${responsive.mobile(css`
    text-align: unset;
  `)}
`;

const Row = styled.div`
  display: flex;
`;

const Target = styled.div`
  height: 44px;
  display: flex;
  border-bottom: 2px solid #058459;

  margin-bottom: 16px;
`;

const TargetLabel = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;

  color: #058459;

  margin: 12px 0px 6px 16px;
`;
